import { render, staticRenderFns } from "./send-push.vue?vue&type=template&id=63ccdc14&"
import script from "./send-push.vue?vue&type=script&lang=js&"
export * from "./send-push.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VSpacer,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63ccdc14')) {
      api.createRecord('63ccdc14', component.options)
    } else {
      api.reload('63ccdc14', component.options)
    }
    module.hot.accept("./send-push.vue?vue&type=template&id=63ccdc14&", function () {
      api.rerender('63ccdc14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/send-push.vue"
export default component.exports